import { Injectable, signal } from '@angular/core';
import { CourseI } from '../courses/interfaces/course.interface';
import { FilterCoursesI } from '../courses/interfaces/filter-courses.interface';
import { FilterStudentsI } from '../students/interfaces/filter-students.interface';
import { StudentI } from '../students/interfaces/student.interface';
import { FilterProgramsI } from './interfaces/filter-programs.interface';
import { ProgramI } from './interfaces/program.interface';
import { PloI } from '../../shared/interfaces/plo.interface';
import { ProgramGoalI } from './programs-details/program-goals/interfaces/program-goal.interface';
import { FilterProgramGoalsQueryI } from './programs-details/program-goals/interfaces/filter-program-goal-query.interface';
import { CompetenciesI } from '../../shared/interfaces/competency.interface';
import { FilterAllProgramPlosDto } from './dtos/find-all-program-plos.dto';
import { FilterCoursesCompletionsI } from './interfaces/filter-courses-completions.interface';
import { FilterCourseSectionsI } from '../course-sections/interfaces/filter-course-sections.interface';

@Injectable({
  providedIn: 'root',
})
export class ProgramsService {
  constructor() {}

  selectedProgram = signal<ProgramI | null>(null);

  filterPrograms = signal<FilterProgramsI | null>(null);

  editProgram = signal<ProgramI | null>(null);

  addProgram = signal<ProgramI | null>(null);

  deleteProgram = signal<ProgramI | null>(null);

  selectedProgramForReport = signal<string | null>(null);

  reportResultsNavigator = signal<number>(1);

  // ******************************************** ||

  filterCourses = signal<FilterCoursesI | null>(null);

  editCourse = signal<CourseI | null>(null);

  addCourse = signal<CourseI | null>(null);

  // ******************************************** ||

  filterStudents = signal<FilterStudentsI | null>(null);

  editStudent = signal<StudentI | null>(null);

  addStudent = signal<StudentI | null>(null);

  // ******************************************** ||

  filterPlos = signal<FilterAllProgramPlosDto | null>(null);

  editPlo = signal<PloI | null>(null);

  addPlo = signal<PloI | null>(null);

  deletePlo = signal<PloI | null>(null);
  // ******************************************** ||

  competencyToUpdate = signal<CompetenciesI | null>(null);

  // ******************************************** ||

  filterCompetencies = signal<FilterAllProgramPlosDto | null>(null);

  updateCompetency = signal<CompetenciesI | null>(null);

  createCompetency = signal<CompetenciesI | null>(null);

  removeCompetency = signal<CompetenciesI | null>(null);
  // ******************************************** ||

  updateGoal = signal<ProgramGoalI | null>(null);

  createGoal = signal<ProgramGoalI | null>(null);

  filterProgramGoals = signal<FilterProgramGoalsQueryI | null>(null);

  deleteGoal = signal<ProgramGoalI | null>(null);

  // ******************************************** ||

  filterForReport = signal<FilterCoursesCompletionsI | null>(null);

  filterCourseSectionOutlier = signal<FilterCourseSectionsI | null>(null);

  filterCoursesClos = signal<FilterCourseSectionsI | null>(null);

  filterCoursesCompletion = signal<FilterCourseSectionsI | null>(null);
}
